<template>
  <div class="wrap app-footer" id="pc-footer">
    <div class="footer-top">
      <el-row class="foot-top-width" :gutter="20">
        <el-col :span="6" v-for="item in footerTop" :key="item.index">
          <el-row type="flex" class="grid-content bg-purple">
            <img class="foot-top-icon" :src="item.imgsrc" />
            <div class="foot-right">
              <h1 class="foot-title-title">{{item.title}}</h1>
              <h1 class="foot-title-content">{{item.content}}</h1>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="footer-bottom" v-if="false">
      <el-row class="foot-top-width">
        <el-col v-for="item in footerBottom" :key="item.index" style="width:20%;">
          <div class="footer-bottom-title">{{item.title}}</div>
          <div class="footer-bottom-content" v-for="item in item.content" :key="item.index">
            <a
              class="footer-bottom-content-href"
              @click="dialogFormVisibleAction(item.title)"
            >{{item.title}}</a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer-line">
      <p>
        <a href="http://www.zhonghuilv.com/" target="_blank">中惠旅集团</a> |
        <a href="https://www.huiqulx.com/" target="_blank">惠旅商城</a> |
        <!-- <a href="http://ai-lvxing.com/" target="_blank">AI旅行</a> | -->
        <a href="http://huilvzn.com/" target="_blank">惠旅智能</a> |
        <a href="http://www.shiniuzhai.com/" target="_blank">岳阳石牛寨旅游</a> |
        <a href="http://www.shiyanhu.com/" target="_blank">长沙景区石燕湖</a> |
        <a href="http://www.lys-piaoliu.com/" target="_blank">连云山漂流</a> |
        <a href="http://www.xtxfjq.com/" target="_blank">侠天下景区</a> |
        <a href="http://jl-jiang.com/" target="_blank">九龙江风景区</a> |
        <a>
          <img src="/static/images/gongan.png" />
          <span>湘公网安备 43010302000958号</span>
        </a>
      </p>
    </div>
    <div class="footer-foot">
      <p class="footer-foot-bottom-label">
        <a
          style="text-decoration: none;font-size: 14px;color: #999999;"
          href="http://huiqulx-images.oss-cn-shenzhen.aliyuncs.com/xcximg/record.jpg"
          target="_blank"
        >增值电信业务许可证:湘B2-20170074</a>
        <span>商标注册号:第23494994号</span>
        <span>旅行社业务许可证:长旅函【2017】36号</span>©湖南惠旅云网络科技有限公司版权所有
        <a
          style="text-decoration: none;font-size: 14px;color: #999999;"
          href="http://beian.miit.gov.cn/"
          target="_blank"
        >湘ICP备12010097号-9</a>
      </p>
      <p class="footer-foot-bottom-img">
        <a href="http://report.12377.cn:13225/toreportinputNormal_anis.do" target="_blank">
          <img class="footImg1" src="/static/images/foot-partner-img1.png" />
        </a>
        <img class="footImg2" src="/static/images/foot-partner-img2.png" />
        <img class="footImg3" src="/static/images/foot-partner-img3.png" />
        <a href="http://www.zx110.org/" target="_blank">
          <img class="footImg4" src="/static/images/foot-partner-img4.png" />
        </a>
        <a href="http://315.voc.com.cn/" target="_blank">
          <img class="footImg5" src="/static/images/foot-partner-img5.png" />
        </a>
        <a href="http://shuidi.cn/" target="_blank">
          <img class="footImg6" src="/static/images/foot-partner-img6.png" />
        </a>
        <a href="http://wfblxx.rednet.cn/" target="_blank">
          <img class="footImg7" src="/static/images/foot-partner-img7.png" />
        </a>
        <a href="http://www.gsxt.gov.cn/index.html" target="_blank">
          <img class="footImg8" src="/static/images/foot-partner-img8.png" />
        </a>
        <a href="https://www.creditchina.gov.cn/" target="_blank">
          <img class="footImg9" src="/static/images/foot-partner-img9.png" />
        </a>
      </p>
    </div>
    <el-dialog title="投诉建议" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="文字描述">
          <el-input
            v-model="form.name"
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="form.tel" placeholder="请输入联系方式" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          style="color: orange;"
          type="warning"
          plain
        >取 消</el-button>
        <el-button
          type="warning"
          style="background-color: orange;"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'pc-footer',
  data () {
    return {
      dialogFormVisible: false,
      form: {},
      footerTop: [
        {
          imgsrc: '/static/images/footer-icon1.png',
          title: '价格保障',
          content: '同类产品 保证低价'
        },
        {
          imgsrc: '/static/images/footer-icon2.png',
          title: '行程保障',
          content: '品质保证 放心出行'
        },
        {
          imgsrc: '/static/images/footer-icon3.png',
          title: '产品保障',
          content: '品质保证 放心出行'
        },
        {
          imgsrc: '/static/images/footer-icon4.png',
          title: '7×24小时服务',
          content: '专属客服 快速响应'
        }
      ],
      footerBottom: [
        {
          title: '关于惠趣',
          content: [
            { title: '惠趣介绍' },
            { title: '惠趣历程' },
            { title: '加入惠趣' },
            { title: '惠趣周边' },
            { title: '联系我们' }
          ]
        },
        {
          title: '惠趣服务',
          content: [
            { title: '会员服务' },
            { title: '资讯攻略' },
            { title: '积分兑换' },
            { title: '投诉建议' }
          ]
        },
        {
          title: '产品服务',
          content: [
            { title: '酒店住宿' },
            // { title: "机票预订" },
            // { title: "火车票预订" },
            { title: '旅游目的地' },
            { title: '惠趣特卖会' }
          ]
        },
        {
          title: '用户指南',
          content: [
            { title: '门票预订' },
            { title: '酒店预订' },
            // { title: "机票须知" },
            // { title: "飞机票须知" },
            { title: '汇率换算' },
            { title: '用户协议' }
          ]
        },
        {
          title: '合作中心',
          content: [
            { title: '供应商合作' },
            { title: '分销商合作' },
            // { title: '商旅合作' },
            { title: '商务合作' },
            { title: '合作案例 ' }
          ]
        }
      ]
    }
  },
  methods: {
    dialogFormVisibleAction (title) {
      if (title == '投诉建议') {
        this.dialogFormVisible = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$width: 1200px;
$bgColor: white;
#pc-footer {
  .footer-top {
    background: #f4f4f4;
    padding: 33px 0px;
    .foot-top-width {
      width: $width;
      .foot-top-icon {
        width: 29px;
        height: 34px;
      }
      .foot-right {
        margin-left: 16px;
        h1 {
          margin: 0px;
          text-align: left;
          color: #333333;
        }
        .foot-title-title {
          font-size: 14px;
          margin-bottom: 7px;
        }
        .foot-title-content {
          font-size: 12px;
        }
      }
    }
  }
  .footer-bottom {
    background-color: $bgColor;
    .foot-top-width {
      width: $width;
      text-align: left;
      padding: 28px 0px;
      border-bottom: 1px solid rgba(239, 239, 244, 1);
      .footer-bottom-title {
        font-size: 14px;
        color: #333333;
        margin-bottom: 20px;
      }
      .footer-bottom-content {
        font-size: 12px;
        color: #999999;
        margin-bottom: 5px;
        .footer-bottom-content-href:hover {
          color: #ec6616;
          cursor: pointer;
        }
      }
    }
  }
  .footer-line,
  .footer-foot {
    background-color: $bgColor;
  }
  .footer-line p,
  .footer-foot p {
    width: $width;
    font-size: 14px;
    color: #999999;
    margin: 0 auto;
  }
  .footer-line {
    padding: 32px 0px 35px;
  }
  .footer-line a {
    font-size: 14px;
    color: #999999;
    text-decoration: none;
  }
  .footer-foot {
    padding-bottom: 60px;
  }
  .footer-foot p.footer-foot-bottom-img {
    text-align: left;
    font-size: 0px;
  }
  .footer-foot-bottom-label span {
    margin-right: 14px;
  }
  p.footer-foot-bottom-img img {
    margin-top: 14px;
  }
  .footImg1 {
    width: 183px;
    height: 48px;
    margin-right: 44px;
  }
  .footImg2 {
    width: 107px;
    height: 40px;
    margin-right: 42px;
  }
  .footImg3 {
    width: 107px;
    height: 40px;
    margin-right: 50px;
  }
  .footImg4 {
    width: 108px;
    height: 35px;
    margin-right: 61px;
  }
  .footImg5 {
    width: 137px;
    height: 35px;
    margin-right: 61px;
  }
  .footImg6 {
    width: 153px;
    height: 40px;
    margin-right: 66px;
  }
  .footImg7 {
    width: 74px;
    height: 30px;
  }
  .footImg8 {
    width: 231px;
    height: 26px;
    margin-right: 72px;
  }
  .footImg9 {
    width: 117px;
    height: 30px;
  }
}
</style>
<style lang="scss">
.app-footer {
  .foot-top-width {
    margin: 0 auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/footer.vue